/* Martin Auto Detailing: ChatGPT Ads contact form measurement.
 * Install once across storefront pages. Shopify Forms ID 111026 only.
 * Counts a submitted form only after Shopify displays its success step.
 * This custom hook does not read form field values. The official SDK may
 * apply the pixel's automatic advanced matching after consent is allowed.
 */
(function (w, d) {
  'use strict';
  if (w.__madChatGPTFormTracking) return;
  w.__madChatGPTFormTracking = true;

  var pixelId = 'L2CDxM5DWP5qTJ1Vg7KHXm';
  var selector = '[data-forms-id="forms-root-111026"]';
  var initialized = false;
  var lastConsent;
  var privacyLoading = false;

  function allowed() {
    var p = w.Shopify && w.Shopify.customerPrivacy;
    try {
      return !!(p && p.analyticsProcessingAllowed() &&
        p.marketingAllowed() && p.saleOfDataAllowed());
    } catch (_) { return false; }
  }

  function syncConsent() {
    var consent = allowed();
    // Wait for permission before loading the SDK or creating attribution cookies.
    if (!initialized && !consent) return false;
    if (!initialized) {
      if (!w.oaiq) {
        var q = function () { q.q.push(arguments); };
        q.q = [];
        w.oaiq = q;
        var js = d.createElement('script');
        js.async = true;
        js.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
        d.head.appendChild(js);
      }
      w.oaiq('consent', true);
      w.oaiq('init', { pixelId: pixelId });
      initialized = true;
      lastConsent = true;
    } else if (consent !== lastConsent) {
      w.oaiq('consent', consent);
      lastConsent = consent;
    }
    return consent;
  }

  function loadPrivacy(attempt) {
    if (w.Shopify && w.Shopify.customerPrivacy) {
      syncConsent();
    } else if (w.Shopify && w.Shopify.loadFeatures && !privacyLoading) {
      privacyLoading = true;
      w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          privacyLoading = false;
          if (!error) syncConsent();
        });
    } else if (attempt < 60) {
      w.setTimeout(function () { loadPrivacy(attempt + 1); }, 1000);
    }
  }

  d.addEventListener('visitorConsentCollected', syncConsent);
  w.addEventListener('pageshow', syncConsent);
  loadPrivacy(0);

  function attachForm() {
    var container = d.querySelector(selector);
    var host = container && container.querySelector('shopify-forms-embed');
    var root = host && host.shadowRoot;
    if (!root || container.getAttribute('data-mad-chatgpt-tracking')) return;
    container.setAttribute('data-mad-chatgpt-tracking', 'ready');
    discovery.disconnect();
    var pendingId = null;

    function step() {
      var app = root.querySelector('#app-embed');
      return app && app.getAttribute('data-current-step');
    }

    root.addEventListener('submit', function () {
      if (step() !== 'form' || pendingId) return;
      pendingId = 'mad-contact-' + (w.crypto && w.crypto.randomUUID
        ? w.crypto.randomUUID()
        : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2));
    }, true);

    var successObserver = new MutationObserver(function () {
      if (step() !== 'success' || !pendingId) return;
      var eventId = pendingId;
      pendingId = null;
      if (!syncConsent()) {
        container.setAttribute('data-mad-chatgpt-tracking', 'consent-blocked');
        return;
      }
      w.oaiq('measure', 'lead_created', { type: 'customer_action' },
        { event_id: eventId });
      container.setAttribute('data-mad-chatgpt-tracking', 'event-queued');
    });
    successObserver.observe(root, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['data-current-step']
    });
  }

  var discovery = new MutationObserver(attachForm);
  discovery.observe(d.documentElement, { childList: true, subtree: true });
  attachForm();
  if (w.customElements) {
    w.customElements.whenDefined('shopify-forms-embed').then(attachForm);
  }
})(window, document);
